import { QueryBuilderGroupConfig } from '@datachain/ui-sdk/components/query-builder';
import { immerable, produce } from 'immer';
import { Set } from 'immutable';

interface IFilterModelItemEntity {
	id: string;
	label: string;
	description: string;
	root: QueryBuilderGroupConfig;
	linkedProfileIds: Set<string>;
	isInSync: boolean;
}

const entityDefaults: IFilterModelItemEntity = {
	id: '',
	label: '',
	description: '',
	root: {
		condition: 'or',
		rules: [],
	},
	linkedProfileIds: Set(),
	isInSync: false,
};

export class FilterModelItemEntity implements IFilterModelItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public root = entityDefaults.root;
	public linkedProfileIds = entityDefaults.linkedProfileIds;
	public isInSync = entityDefaults.isInSync;

	public static build(
		params: Partial<IFilterModelItemEntity> = {}
	): FilterModelItemEntity {
		const instance = new FilterModelItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.root = params.root ?? entityDefaults.root;
		instance.linkedProfileIds =
			params.linkedProfileIds ?? entityDefaults.linkedProfileIds;
		instance.isInSync = params.isInSync ?? entityDefaults.isInSync;

		return instance;
	}

	public setLabel(label: string): FilterModelItemEntity {
		return produce(this, (draft) => {
			draft.label = `${label} - duplicated`;
		});
	}

	public setDescription(description: string): FilterModelItemEntity {
		return produce(this, (draft) => {
			draft.description = description;
		});
	}

	public setRules(root: QueryBuilderGroupConfig): FilterModelItemEntity {
		return produce(this, (draft) => {
			draft.root = root;
		});
	}
}
